import React from 'react'
import AppDevelopmentTypePage from './AppDevelopmentTypePage'
import { appDevelopmentTypeContent } from './appDevelopmentTypeContent'

const CustomHealthcareAppDevelopment = () => <AppDevelopmentTypePage content={appDevelopmentTypeContent.healthcare} />

export default CustomHealthcareAppDevelopment
